import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { EditoDaytimePackListItem } from 'app/typings/core/admin/packs/editoPackList';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useEditoDaytimePacks() {
  return useQuery({
    queryKey: [CORE_QUERY_KEYS.editoPacks],
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getEditosPacks,
      }) as Promise<EditoDaytimePackListItem[]>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
  });
}
